/**
 * Chart-study periods (stock Chart Terminal / Technical Analysis).
 *
 * These are lookback lengths over a close series, not window keys. A 1M
 * series (23 live sessions) cannot form MA50 — the study is omitted, never
 * zero-filled (R2b).
 */
export const MA_PERIODS = [50, 100, 150, 200] as const;
export type MaPeriod = (typeof MA_PERIODS)[number];

/** Wilder RSI lookback. First defined value needs `RSI_PERIOD + 1` closes. */
export const RSI_PERIOD = 14;

/** MACD fast EMA period (standard 12, 26, 9). */
export const MACD_FAST = 12;
/** MACD slow EMA period. */
export const MACD_SLOW = 26;
/** MACD signal EMA period, applied to the MACD line. */
export const MACD_SIGNAL = 9;
